import { ApiCore } from '../_utilities/core';

const permissions = new ApiCore({
  url: '/auth/permissions',
});

export default {
  getPermissions: () => permissions.read(),
};
